// src/components/charts/WeightChart.jsx
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
} from "recharts";

export default function WeightChart({ series = [], color = "#7EDBB6" }) {
    // series 정규화: 다양한 키를 받아서 { date, kg }로 맞춰줌
    const normalized = (series ?? []).map((r, idx) => {
        if ("date" in r && "kg" in r) return r; // 이미 맞는 형태면 그대로
        const date = r.date ?? r.label ?? String(idx + 1).padStart(2, "0");
        const kg = Number(r.kg ?? r.weight ?? r.value);
        return { date, kg };
    }).filter((r) => Number.isFinite(r.kg));

    // 차트엔 최근 7개만 사용 (원하면 전체로 바꿔도 OK)
    const data = normalized.slice(-7);

    const values = data.map((d) => d.kg);
    const min = values.length ? Math.min(...values) : 0;
    const max = values.length ? Math.max(...values) : 1;

    const CustomDot = (props) => {
        const { cx, cy } = props;
        return <circle cx={cx} cy={cy} r={5} fill={color} />;
    };

    return (
        <div className="h-32 md:h-[13rem]">
            <ResponsiveContainer>
                <LineChart data={data} margin={{ left: 0, right: 0, top: 10, bottom: 10 }}>
                    <CartesianGrid stroke="#e5e7eb" vertical={false} />

                    <XAxis dataKey="date" hide padding={{ left: 24, right: 24 }} />

                    <YAxis
                        type="number"
                        domain={[Number(min), Number(max)]}
                        ticks={[Number(max), Number(min)]}
                        axisLine={false}
                        tickLine={false}
                        width={36}
                        tick={{ fontSize: 12, fill: "#6b7280" }}
                    />

                    <Tooltip
                        formatter={(v) => `${Number(v).toFixed(1)} kg`}
                        contentStyle={{ fontSize: "12px" }}
                    />

                    <Line
                        type="monotone"
                        dataKey="kg"
                        stroke={color}
                        strokeWidth={1}
                        dot={<CustomDot />}
                        activeDot={{ r: 5, fill: color }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}